import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
import isBetween from 'dayjs/plugin/isBetween'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import isoWeek from 'dayjs/plugin/isoWeek'
import advancedFormat from 'dayjs/plugin/advancedFormat'
// dayjs locale data for each supported language. Keep in sync with the
// registry in src/config/languages.ts (the `dayjs` field of each entry).
import 'dayjs/locale/en'
import 'dayjs/locale/es'
import 'dayjs/locale/fr'
import 'dayjs/locale/it'
import 'dayjs/locale/nl'
import 'dayjs/locale/pt'
import 'dayjs/locale/pt-br'
import 'dayjs/locale/uk'

// ─────────────────────────────────────────────────────────────
// The ONLY configuration point for the date library.
// All plugins are registered here once. No other file should call
// dayjs.extend() or import 'dayjs' directly
// (see the no-restricted-imports ESLint rule).
//
// To migrate to another date library in the future, this file is
// the main place to change.
// ─────────────────────────────────────────────────────────────
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(customParseFormat)
dayjs.extend(duration)
dayjs.extend(isBetween)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)
dayjs.extend(isoWeek)
dayjs.extend(advancedFormat)

// Single, enforced entry point. Exported by name (not default) so every
// consumer must import it as `{ datetime }` — a default export could be
// imported under any name (dayjs, moment, d…), breaking the consistency.
export const datetime = dayjs

// This is the ONLY file allowed to touch 'dayjs'. It re-exports the
// library types the layer needs, so no other file imports from 'dayjs'.
export type { Dayjs, ConfigType, OpUnitType, QUnitType, ManipulateType } from 'dayjs'
